import { createFileRoute } from "@tanstack/react-router";
import ConnectorTypesPage from "@/features/connector-types/ConnectorTypesPage";
import { requireRole } from "@/lib/auth/require-role";

export const Route = createFileRoute("/_admin/connectors/types")({
  beforeLoad: () => requireRole("admin"),
  component: ConnectorTypesPage,
});
